/**
 * @author Hiroki Moto
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import DatePicker from '@components/@core/DatePicker';
import Dropdown from '@components/@core/Dropdown';
import ReviewChart from './ReviewChart';
import ExposureChart from './ExposureChart';
import { PRODUCT_REPORT_EXPOSURE, PRODUCT_REPORT_REVIEWS } from '~/services/constants';

const moment = extendMoment(originalMoment);

const Visibility = ({ company, date, onDateChange }) => {
    const products = company?.products || [];
    const [selectedProduct, setSelectedProduct] = useState(null);

    const handleSelectReviews = (e) => {};

    const handleSelectExposure = (e) => {};

    return (
        <div className="card mt-3">
            <p className="dsl-b24 bold">Visibility</p>
            <div className="d-h-between border-bottom py-3">
                <Dropdown className="visibility-product" placeholder="All Products" data={products} getValue={(e) => e.name} returnBy="data" onChange={(e) => setSelectedProduct(e[0])} />
                <DatePicker calendar="range" append="caret" format="MMM D, YY" as="span" align="right" value={date} closeAfterSelect onSelect={onDateChange} />
            </div>
            <div className="mt-4">
                <p className="dsl-b18 bold">Reviews</p>
                <div className="d-flex ssm-column">
                    <div className="d-flex-1">
                        <div className="visibility-item mt-3">
                            <p className="label dsl-b12">New Reviews</p>
                            <p className="dsl-b16">{selectedProduct?.stats?.rating_count || 0}</p>
                        </div>
                        <div className="visibility-item">
                            <p className="label dsl-b12">Avg Ratings</p>
                            <p className="dsl-b16">{Number(selectedProduct?.stats?.rating_avg).toFixed(2)}</p>
                        </div>
                        <div className="visibility-item">
                            <p className="label dsl-b12">Recommended %</p>
                            <p className="dsl-b16">{Number(selectedProduct?.stats?.rating_recommended_avg).toFixed(2)}%</p>
                        </div>
                    </div>
                    <div className="d-flex-2">
                        <Dropdown className="visibility-product" data={PRODUCT_REPORT_REVIEWS} getValue={(e) => e.name} onChange={handleSelectReviews} />
                        <ReviewChart company={selectedProduct} date={date} />
                    </div>
                </div>
            </div>
            <div className="mt-4">
                <p className="dsl-b18 bold">Exposure</p>
                <div className="d-flex ssm-column">
                    <div className="d-flex-1">
                        <div className="visibility-item mt-3">
                            <p className="label dsl-b12">Impressions</p>
                            <p className="dsl-b16">{selectedProduct?.stats?.impressions || 0}</p>
                        </div>
                        <div className="visibility-item">
                            <p className="label dsl-b12">Views</p>
                            <p className="dsl-b16">{selectedProduct?.stats?.views || 0}</p>
                        </div>
                        <div className="visibility-item">
                            <p className="label dsl-b12">Clicks</p>
                            <p className="dsl-b16">{selectedProduct?.stats?.clicks || 0}</p>
                        </div>
                    </div>
                    <div className="d-flex-2">
                        <Dropdown className="visibility-product" data={PRODUCT_REPORT_EXPOSURE} getValue={(e) => e.name} onChange={handleSelectExposure} />
                        <ExposureChart company={selectedProduct} date={date} />
                    </div>
                </div>
            </div>
        </div>
    );
};

Visibility.propTypes = {
    company: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        products: PropTypes.array,
        stats: PropTypes.shape({
            product_count: PropTypes.number,
            popularity_score: PropTypes.number,
            rating_recommended_avg: PropTypes.number,
            rating_count: PropTypes.number,
            rating_dealership_count: PropTypes.number,
        }),
    }),
    date: PropTypes.any,
    onDateChange: PropTypes.func,
};

Visibility.defaultProps = {
    company: {
        id: 0,
        name: '',
        products: [],
        stats: {
            product_count: 0,
            popularity_score: 0,
            rating_recommended_avg: 0,
            rating_count: 0,
            rating_dealership_count: 0,
        },
    },
    date: moment.range(moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')),
    onDateChange: () => {},
};

export default Visibility;
